export default angular
  .module("AliasListCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("AliasListController", [
    "$scope",
    "$location",
    "$rootScope",
    "Aliases",
    function (
      $scope,
      $location,
      $rootScope,
      Aliases,
    ) {
      // default alias script list view settings
      $rootScope.aliasPageCount = $rootScope.aliasPageCount || 1
      $rootScope.aliasPageSize = $rootScope.aliasPageSize || 20;
      $scope.searchString = $rootScope.aliasListFilter;
      $scope.sortAliases = [];
      $scope.sortAliases.column = "NAME";
      $scope.sortAliases.direction = false; // descending direction
      $scope.currentPage = $rootScope.aliasListPage || 1;


      $scope.decodeGroupDescription = (groupId) => {
        switch (groupId) {
          case 1: return "Diagnosis";
          case 3: return "Drug";
          case 5: return "Result";
          case 11: return "Procedure";
          case 13: return "Risk";
          case 14: return "Vaccination";
          default: return "";
        }
      };

      $scope.userUserFullname = (user) => {
        if (user) {
          return user.USER_FULL_NAME;
        }
        return "";

      }

      const setPage = (page) => {
        $scope.currentPage = page;
        $rootScope.aliasListPage = page;
        if (!Aliases.loading.aliases) {
          Aliases.loadAliases({ page, limit: $scope.aliasPageSize, filter: $scope.searchString }, (_, count) => {
            $rootScope.aliasPageCount = count;
          });
        }
      };

      $scope.filterChanged = function () {
        setPage(1);
      };

      $scope.pageChanged = setPage;

      $scope.aliases = Aliases.getAliases;
      $rootScope.aliases = Aliases.getAliases;
      $scope.loading = Aliases.loading;

      $scope.openAliasURL = (id) => {
        $location.path(`/alias/${id}`);
      };

      // When aliasPageSize changes, reload aliases
      $rootScope.$watch(
        "aliasPageSize",
        () => {
          setPage(1);
        },
        true,
      );
      // Sets list sort according to Alias' column
      // Also toggles between ascending and descending
      $scope.changeSorting = (column) => {
        if ($scope.sortAliases.column === column) {
          $scope.sortAliases.direction = !$scope.sortAliases.direction;
        } else {
          $scope.sortAliases.column = column;
          $scope.sortAliases.direction = false;
        }
      };
    },
  ]);
